module.exports = __webpack_public_path__ + "static/media/github-sample-api.555ec19b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/github-sample-api.png
// module id = 43
// module chunks = 0